import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { CommunicationLogEntryModel } from 'models/generated/Communication.Api.Models.CommunicationLogEntry';
import { CommunicationLogEntryDtoModel } from 'models/generated/Communication.Api.Models.CommunicationLogEntryDto';
import { MailDtoModel } from 'models/generated/Communication.Api.Models.MailDto';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class CommunicationService {

	private baseUrl = `${environment.gatewayUrl}/api/communications`;

	constructor(private readonly http: HttpClient) {

	}

	updateCommunicationLogEntry(entryId: string, newComment: string, notifyUsersById: string[] = []): Promise<CommunicationLogEntryModel> {
		const entry = new CommunicationLogEntryDtoModel();
		entry.userIdsToNotify = notifyUsersById;
		entry.comment = newComment;
		return firstValueFrom(this.http.put<CommunicationLogEntryModel>(`${this.baseUrl}/log-entries/${entryId}`, entry));
	}
	addCommunicationLogEntry(newComment: string, companyId: string, taskflowId?: string, taskActionId?: string, notifyUsersById: string[] = []): Promise<CommunicationLogEntryModel> {
		const entry = new CommunicationLogEntryDtoModel();
		entry.companyId = companyId;
		entry.taskflowId = taskflowId;
		entry.taskActionId = taskActionId;
		entry.userIdsToNotify = notifyUsersById;
		entry.comment = newComment;
		return firstValueFrom(this.http.post<CommunicationLogEntryModel>(`${this.baseUrl}/log-entries/comment`, entry));
	}

	getLogEntry(entryId: string): Promise<CommunicationLogEntryModel> {
		return firstValueFrom(this.http.get<CommunicationLogEntryModel>(`${this.baseUrl}/log-entries/${entryId}`));
	}

	getLogEntries(companyId: string): Promise<CommunicationLogEntryModel[]> {
		return firstValueFrom(this.http.get<CommunicationLogEntryModel[]>(`${this.baseUrl}/log-entries/company/${companyId}`));
	}
	getLogEntriesForTaskflow(taskflowId: string): Promise<CommunicationLogEntryModel[]> {
		return firstValueFrom(this.http.get<CommunicationLogEntryModel[]>(`${this.baseUrl}/log-entries/taskflow/${taskflowId}`));
	}

	sendMail(content: string, subject: string, recipients: string[], companyId: string, taskflowId?: string, taskActionId?: string, trackingId?: string): Promise<CommunicationLogEntryModel> {
		const mail = new MailDtoModel();
		mail.companyId = companyId;
		mail.taskflowId = taskflowId;
		mail.taskActionId = taskActionId;
		mail.trackingId = trackingId;
		mail.subject = subject;
		mail.content = content;
		mail.recipients = recipients;
		return firstValueFrom(this.http.post<CommunicationLogEntryModel>(`${this.baseUrl}/send-mail`, mail));
	}
}
